import React, { useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { History } from 'history';
import { Row, Col } from 'antd';
import classnames from 'classnames';

import { PageHeader } from '../layout/PageHeader';
import { EmptyContainer } from '../layout/EmptyContainer';
import { PaymentCardList } from './PaymentList';
import { getCustomers } from '../../store/payment/actions';

import LogoIcon from '../../assets/images/png/payment-card-large.png';
import { FloatingButton } from '../layout/FloatingButton';
import { useDispatch, useSelector } from 'react-redux';
import { getCustomerState } from '../../store/payment/selectors';

export const PaymentListContent: React.FC = () => {
  const history: History = useHistory();
  const { customers } = useSelector(getCustomerState);

  const navigate = () => history.push('/payment/add');

  return (
    <React.Fragment>
      {customers.length ? (
        <Col span={24} className="payment-wrapper">
          <PaymentCardList cards={customers} />
          <FloatingButton onClick={navigate} />
        </Col>
      ) : (
        <EmptyContainer
          icon={LogoIcon}
          title="You have no card added"
          onClick={navigate}
        />
      )}
    </React.Fragment>
  );
};

export const Payment: React.FC = () => {
  const dispatch = useDispatch();
  const cards = [];
  const getCustomersData = () => {
    dispatch(getCustomers());
  };
  const containerClass = classnames({
    'bank-container': true,
    'with-background': cards.length === 0,
  });
  useEffect(getCustomersData, []);
  return (
    <div className="bank-account-container">
      <PageHeader headerTitle="Payment Card" />
      <Row justify="center" className={containerClass}>
        <PaymentListContent />
      </Row>
    </div>
  );
};
